import { render, staticRenderFns } from "./IconBase.vue?vue&type=template&id=8d9deb0e&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"
import style0 from "./IconBase.vue?vue&type=style&index=0&id=8d9deb0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9deb0e",
  null
  
)

export default component.exports